import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import {
  OMC,
  Fuels,
  productCatogories,
  Shifts,
  BankAccountType,
  Banks,
  swipeMachines,
  Wallets,
} from '@C/Director/Utils/RouteComponents';

const RouteSetup = () => {
  return (
    <Switch>
      <Route path="/crm/omc" component={OMC} />
      <Route path="/crm/fuels" component={Fuels} />
      <Route path="/crm/product-catogories" component={productCatogories} />
      <Route path="/crm/shifts" component={Shifts} />
      <Route path="/crm/bank-account-type" component={BankAccountType} />
      <Route path="/crm/banks" component={Banks} />
      <Route path="/crm/swipe-machines" component={swipeMachines} />
      <Route path="/crm/wallet" component={Wallets} />
      <Route path="/crm/*">
        <Redirect to={`/crm/omc`} />
      </Route>
    </Switch>
  );
};

export { RouteSetup };
